
import { RichText } from '@wordpress/block-editor';
import BlockContext from "../context/blockContext";
import SectionItemContext from "../context/sectionItemContext";
import { useContext } from "@wordpress/element";

const Experience = () => {
    const { updateField, formatDateDisplay } = useContext(BlockContext);
    const { item, index, itemIndex } = useContext(SectionItemContext);
    return (
    <>
        {
            (item.name || item.designation || item.company || item.city || item.country || item.experienceDescription || item.fromExpDate || item.toExpDate) && (
                <div className="cv-experience">
                <RichText
                    tagName="span"
                    className="company-name"
                    value={item.name}
                    onChange={(value) => updateField(index, "name", value, itemIndex)}
                    placeholder="Enter company name..."
                />
                {item.designation && " - "}
                <RichText
                tagName="span"
                className="designation"
                value={item.designation}
                onChange={(value) => updateField(index, "designation", value, itemIndex)}
                placeholder="Enter designation..."
                />
                <div className="duration">
                    {formatDateDisplay(item.fromExpDate)}
                    {(item.current || item.toExpDate) ? ` - ${item.current ? "Present" : formatDateDisplay(item.toExpDate)}` : ""}
                </div>
                <RichText
                className="description"
                value={item.experienceDescription}
                onChange={(value) => updateField(index, "experienceDescription", value, itemIndex)}
                placeholder="Enter section description..."
                />
            </div>
            )
        }
    </>
  )
}

export default Experience
